import {facebookApi} from './core/facebook-api';
import {googleApi} from './core/google-api';

(async (window: any) => {
  const fb = await facebookApi.fb;
  const gapi = await googleApi.gapi;

  window.signOutFacebook = async () => await facebookApi.graph('/me/permissions', 'delete');
  window.signOutGoogle = async () => gapi.auth2.getAuthInstance().signOut(); // .disconnect();
  window.signOut = () => Promise.all([window.signOutFacebook(), window.signOutGoogle()]);
})(window);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/_debug.ts